import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
  'https://nldomlrrpqflnwafwato.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5sZG9tbHJycHFmbG53YWZ3YXRvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcwNDcwODEsImV4cCI6MjA5MjYyMzA4MX0.UJSB2B8vox5bXS6V2e-UVbRSapm0uMgKTFpOIUztSCk',
  { auth: { persistSession: true, autoRefreshToken: true } }
)

export default supabase
